import { page } from '$app/stores';
import { get } from 'svelte/store';
import type { GlobalSettingsType } from './queries/GlobalSettingsQuery';
import type { GenreDataType } from './types/GenreData';
import { Bugs } from '$lib/BugsService';

export class Genres {
	public static FREE_GENRE_ID = '156559631';

	public static get all(): GenreDataType[] {
		// Bugs.error()
		const genres = get(page).data?.globals?.genres;
		if (!genres) {
			Bugs.reportError(new Error('Missing global genres object'), {
				trace: 'Globals.all;',
				page: get(page)
			});
		}
		return genres ?? [];
	}

	public static getById(id: string) {
		return Genres.all.find((genre) => genre.id === id);
	}

	public static getBySlugs(slugs: string[]) {
		return Genres.all.filter((genre) => slugs.includes(genre.slug));
	}

	public static includesFreeGenre(genres?: { id: string }[]) {
		if (!genres) return false;
		return genres.some((genre) => genre.id === Genres.FREE_GENRE_ID);
	}

	public static async genreSlugToIds(genreSlugs: string[]): Promise<string[]> {
		return genreSlugs.map((genreSlug) => {
			return Genres.all.find((g) => g.slug === genreSlug)?.id ?? '';
		});
	}
}

class Globals {
	public get data(): GlobalSettingsType {
		return get(page).data.globals;
	}
}

export const globals = new Globals();
